export class GenericKendoGridColumnDefinition{
    public values?: any[];
    constructor(
         public field: string,
         public title: string,
         public format: string ='',
         public filterable: boolean = true,
         public columnMenu:boolean = false,
         public aggregates:Array<string> = [],
         public footerTemplate: string = "",
         public groupFooterTemplate: string = "",
         public groupHeaderTemplate: string = "",
         public hidden:boolean = false,
         public attributes:Object = {},
         public groupable: boolean | Object = true,
         public width:number = 180,
         public headerAttributes: Object = {},
         public sortable: boolean | Object = true,
         public template?: string | Function,
         public editable?:boolean
         ){}
}


// WEBPACK FOOTER //
// ./app/insa-models/genericKendoGrid.ts